// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, maybe } from "@altostra/type-validations";
import { boolean, number, string, any } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdBannerTemplatesResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: maybe(string),
      marked_as_deleted: boolean,
      last_edited_at: maybe(number),
      created_by: maybe(string),
      last_edited_by: maybe(string),
      tag_names: arrayOf(string),
      territory_ids: arrayOf(string),
      last_edited_info: maybe(
        objectOf({
          d_id: string,
          name: string,
          time: number,
        })
      ),
      created_by_info: maybe(
        objectOf({
          d_id: string,
          name: string,
          time: number,
        })
      ),
      html: string,
    })
  ),
});

export const isPostEngagementAppGroupIdBannerTemplatesResult = objectOf({
  template: objectOf({
    id: string,
    name: string,
    description: string,
    marked_as_deleted: boolean,
    last_edited_at: number,
    created_by: string,
    last_edited_by: string,
    last_edited_info: objectOf({
      d_id: string,
      name: string,
      time: number,
    }),
    created_by_info: objectOf({
      d_id: string,
      name: string,
      time: number,
    }),
    grapes_js_data: any,
    tag_names: arrayOf(string),
    territory_ids: arrayOf(string),
    html: string,
  }),
  info: string,
});
